/**
 * Keeps post-newsletter redirect UX smooth while using native Shopify forms:
 * - ensures animation=0 is present after submit redirects
 * - scrolls back to the newsletter area when customer_posted is in URL
 */
(function() {
  function hasCustomerPosted(url) {
    return (url.searchParams.get('customer_posted') || '').toLowerCase() === 'true';
  }

  function isCaptchaNewsletterReturn(url) {
    var formType = (url.searchParams.get('form_type') || '').toLowerCase();
    var tags = (url.searchParams.get('contact[tags]') || '').toLowerCase();
    var contactId = (url.searchParams.get('contact[id]') || '').toLowerCase();
    return formType === 'customer' && tags.indexOf('newsletter') !== -1 && contactId !== '';
  }

  function isNewsletterSuccessUrl(url) {
    return hasCustomerPosted(url) || isCaptchaNewsletterReturn(url);
  }

  function getNewsletterContainer(url) {
    var contactId = (url.searchParams.get('contact[id]') || '').toLowerCase();
    if (contactId.indexOf('passwordnewsletter') !== -1) {
      return document.querySelector('#password-newsletter');
    }
    if (contactId.indexOf('footernewsletter') !== -1) {
      return document.querySelector('#footer-newsletter');
    }
    return document.querySelector('#footer-newsletter') || document.querySelector('#password-newsletter');
  }

  function ensureSuccessMessage(container) {
    if (!container) return;

    var isPassword = container.id === 'password-newsletter';
    var successClass = isPassword ? 'pw-success' : 'newsletter-success';
    var successText = 'Thank you for subscribing';
    var existing = container.querySelector('.' + successClass + '[role="status"]');

    if (existing) {
      existing.textContent = successText;
      existing.style.display = '';
      return;
    }

    var message = document.createElement('p');
    message.className = successClass;
    message.setAttribute('role', 'status');
    message.textContent = successText;

    var form = container.querySelector('form');
    if (form && form.parentNode) {
      form.parentNode.insertBefore(message, form.nextSibling);
      return;
    }

    container.appendChild(message);
  }

  function getScrollTarget() {
    if (window.location.hash) {
      var hashTarget = document.querySelector(window.location.hash);
      if (hashTarget) return hashTarget;
    }
    return getNewsletterContainer(new URL(window.location.href));
  }

  function ensureAnimationFlag(url) {
    if (url.searchParams.get('animation') !== '0') {
      url.searchParams.set('animation', '0');
      history.replaceState({}, '', url.toString());
    }
  }

  function scrollToNewsletter() {
    var target = getScrollTarget();
    if (!target) return;
    requestAnimationFrame(function() {
      target.scrollIntoView({ behavior: 'auto', block: 'start' });
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    var url = new URL(window.location.href);
    if (!isNewsletterSuccessUrl(url)) return;
    ensureAnimationFlag(url);
    ensureSuccessMessage(getNewsletterContainer(url));
    scrollToNewsletter();
  });
})();
